import type { ItemEntity } from '@/features/item/domain/entities/ItemEntity'

export class DiscountOfferItemsResponseEntity {
  readonly remainingItems?: number
  count?: number
  readonly page?: number
  readonly limit?: number
  readonly metadata?: unknown
  items?: Array<ItemEntity> | null
}
